<template>
  <v-app>
    <div  class="main-container">
      <v-chip
        color="#f5a611"
        dark
        class="sessions-btn-25"
        @click="show_sessions()">
        <v-icon small class="ma-1">mdi-plus-box</v-icon>
          График экспериментальных сессий в 2026 году
      </v-chip>

      <div style="width: 100%;">
        <v-row>
            <v-col cols='12'>
              <v-card class="table-data ma-1">
                <v-card-title style="color:gray; font-weight:bold; padding-left: 0px;">
                  <v-chip
                    color="#16336e"
                    dark
                    class="new-proposal"
                    @click="CREATE_PROPOSAL({id: GETTERS_LOGIN})">
                    <v-icon small class="ma-1">mdi-plus-box</v-icon>
                      {{ $t('new_proposal') }}
                  </v-chip>

                  <div style="width: 400px; margin-left: 20px;">
                    <v-tabs v-model="activeTab" fixed-tabs>
                      <v-tab :key="1">Активные</v-tab>
                      <v-tab :key="2">Архив</v-tab>
                      <v-tab :key="3">Удаленные</v-tab>
                    </v-tabs>
                  </div>

                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    :label="$t('search')"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-card-title>

                <v-tabs-items v-model="activeTab" class="white elevation-1">
                  <v-tab-item :key="1">
                    <div class="lists" v-if="GETTERS_LOGIN">
                      <v-data-table
                        no-data-text="Заявки отсутствуют"
                        :headers="headers"
                        :items="listProposals"
                        :search="search"
                        :style="{color: $mainColor}"
                        :loading="list_loading"
                        :loading-text="$t('User.loading_orders')"
                        :items-per-page="20"
                        :footer-props="{
                            itemsPerPageOptions: [10, 20, 50],
                            itemsPerPageText: 'кол-во на стр.:',
                        }"
                      >
                      <template v-slot:item.name="{ item }">
                        <v-tooltip
                          v-if="item.last_status_id==6" right>
                          <template v-slot:activator="{ on, attrs }">
                              <v-btn icon v-bind="attrs" v-on="on"
                                @click="openDetailInfo(item)">
                                  <v-icon color="red lighten-1">mdi-alert-circle</v-icon>
                                </v-btn>
                          </template>
                          <span>{{$t('need_modification')}}</span>
                        </v-tooltip>

                        <span
                        @click="openDetailInfo(item)"
                        style="color: rgba(0, 0, 0, 0.87); cursor:pointer;">
                          {{ item.name ? item.name : $t('untitled') }}
                        </span>
                      </template>
                      <template v-slot:item.status_name="{ item }" >
                          {{item.status_name}}
                          <v-chip
                            class="ma-2"
                            x-small>
                            {{g.toDate(item.last_status_date)}}
                          </v-chip>
                      </template>
                      <template v-slot:item.date_income="{ item }" >
                          {{g.toDate(item.date_income)}}
                      </template>
                      <template v-slot:item.actions="{ item }">
                        <v-tooltip left v-if="item.last_status_id > 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              small
                              v-bind="attrs"
                              v-on="on"
                              @click="openPdf(item.id)">
                              mdi-download
                            </v-icon>
                          </template>
                          <span>{{$t('User.open_pdf')}}</span>
                        </v-tooltip>
                        <v-tooltip left v-if="item.last_status_id == 1 || item.last_status_id == 6">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              small
                              color="gray lighten-1"
                              class="ma-2"
                              v-bind="attrs"
                              v-on="on"
                              @click="goToEditProposal(item)">
                              mdi-pencil
                            </v-icon>
                          </template>
                          <span>{{$t('User.edit_proposal')}}</span>
                        </v-tooltip>

                        <v-tooltip left v-if="item.last_status_id == 1 ">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              small
                              color="red lighten-1"
                              v-bind="attrs"
                              v-on="on"
                              @click="openModal(item)">
                              mdi-delete
                            </v-icon>
                          </template>
                          <span>{{$t('User.delete_proposal')}}</span>
                        </v-tooltip>

                      </template>
                      </v-data-table>
                    </div>
                  </v-tab-item>

                  <v-tab-item  :key="2">
                    <div class="lists" v-if="GETTERS_LOGIN">
                      <v-data-table
                        no-data-text="Заявки отсутствуют"
                          :headers="headers"
                          :items="listArchiveProposals"
                          :search="search"
                          :style="{color: $mainColor}"
                          :loading="list_loading"
                          :loading-text="$t('User.loading_orders')"
                          :items-per-page="20"
                          :footer-props="{
                              itemsPerPageOptions: [10, 20, 50],
                              itemsPerPageText: 'кол-во на стр.:',
                          }"
                      >
                        <template v-slot:item.author="{ item }">
                            <span>
                            {{ item.author }}
                            </span>
                        </template>
                        <template v-slot:item.name="{ item }">
                          <span
                          @click="openDetailInfo(item)"
                          style="color: rgba(0, 0, 0, 0.87); cursor:pointer;">
                            {{ item.name ? item.name : $t('untitled') }}
                          </span>
                        </template>
                        <template v-slot:item.status_name="{ item }" >
                            {{item.status_name}}
                            <v-chip
                              class="ma-2"
                              x-small>
                              {{g.toDate(item.last_status_date)}}
                            </v-chip>
                        </template>
                        <template v-slot:item.date_income="{ item }" >
                            {{g.toDate(item.date_income)}}
                        </template>
                      </v-data-table>
                    </div>
                  </v-tab-item>

                  <v-tab-item  :key="3">
                    <div class="lists" v-if="GETTERS_LOGIN">
                      <v-data-table
                        no-data-text="Заявки отсутствуют"
                          :headers="headers"
                          :items="listDeletedProposals"
                          :search="search"
                          :style="{color: $mainColor}"
                          :loading="list_loading"
                          :loading-text="$t('User.loading_orders')"
                          :items-per-page="20"
                          :footer-props="{
                              itemsPerPageOptions: [10, 20, 50],
                              itemsPerPageText: 'кол-во на стр.:',
                          }"
                      >
                        <template v-slot:item.author="{ item }">
                            <span>
                            {{ item.author }}
                            </span>
                        </template>
                        <template v-slot:item.name="{ item }">
                          <span
                          @click="openDetailInfo(item)"
                          style="color: rgba(0, 0, 0, 0.87); cursor:pointer;">
                            {{ item.name ? item.name : $t('untitled') }}
                          </span>
                        </template>
                        <template v-slot:item.status_name="{ item }" >
                            {{item.status_name}}
                            <v-chip
                              class="ma-2"
                              x-small>
                              {{g.toDate(item.last_status_date)}}
                            </v-chip>
                        </template>
                        <template v-slot:item.date_income="{ item }" >
                            {{g.toDate(item.date_income)}}
                        </template>
                      </v-data-table>
                    </div>
                  </v-tab-item>
                </v-tabs-items>
              </v-card>
            </v-col>
        </v-row>
        <v-dialog
          v-model="deleteDialog"
          max-width="350">
          <v-card style="margin-bottom:0px;">
            <v-card-title class="headline">
              {{ $t('delete-proposal-question') }}
              <v-chip class="ma-2" small>
                {{proposalName}}
              </v-chip>
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="red darken-1"
                text
                :disabled="disabledDelete"
                @click="deleteDialog = false">
                {{ $t('n-delete-proposal-answer') }}
              </v-btn>
              <v-btn
                color="green darken-1"
                text
                :disabled="disabledDelete"
                @click="deleteItem(), disabledDelete = true">
                {{ $t('p-delete-proposal-answer') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
      <widget-render-file
      :name="'user'" />
    </div>

    <v-dialog v-model="sessionsDialog" max-width="75%">
      <session-list
        @closeModal="sessionsDialog = false">
      </session-list>      
    </v-dialog>

    <!-- диалог карточки заявки -->
    <v-dialog v-model="proposalDialogCard">
      <div><v-btn class="primary" @click="proposalDialogCard=false">
        <v-icon>mdi-close</v-icon> Закрыть
      </v-btn></div>
      <user-card
        @updateParent="update_from_proposal()"
        @openPdf="openPdf($event)"
      />
    </v-dialog>
  </v-app>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import WidgetRenderFile from '../components/widgets/render-file'
import UserCard from '../components/Proposals/userCard.vue'
import SessionList from '../components/Common/SessionList.vue'

export default {
  data() {
    return {
      sessionsDialog: false,

      proposalDialogCard: false,
      activeTab: 0,
      disabledDelete: false,
      listProposals: [],
      listArchiveProposals: [],
      listDeletedProposals: [],
      list_loading: false,
      deleteDialog: false,
      proposalName: '',
      deleteId: null,
      search: '',
      headers_base: [
      {text: 'ID', align: 'start', sortable: true, value: 'id'},
        {text: this.$t('name'), sortable: true, value: 'name'},
        {text: 'Станция', align: 'start', sortable: true, value: 'station_name', width: '100px'},
        {text: this.$t('status'), align: 'start', sortable: true, value: 'status_name', width: '200px'},
        {text: this.$t('author'), value: 'author', sortable: true},
        {text: this.$t('date_created'), align: 'start', sortable: true, value: 'date_income', width: '130px'},
        {text: this.$t('actions'), value: 'actions', sortable: false},
      ],
      headers_archive: [
        {text: 'ID', align: 'start', sortable: true, value: 'id'},
        {text: this.$t('name'), sortable: true, value: 'name'},
        {text: 'Станция', align: 'start', sortable: true, value: 'station_name'},
        {text: this.$t('status'), align: 'start', sortable: true, value: 'status_name', width: '200px'},
        {text: this.$t('author'), value: 'author', sortable: true},
        {text: this.$t('date_created'), align: 'start', sortable: true, value: 'date_income', width: '130px'},
      ],
      headers: []
    };
  },
  components: {
    UserCard,
    SessionList,
    WidgetRenderFile
  },
  beforeMount() {
    this.activeTab = 0
    this.headers = this.headers_base
    this.load_proposals()
  },

  methods: {
    ...mapActions([
      'LOAD_LIST_MY_PROPOSALS',
      'CREATE_PROPOSAL',
      'DELETE_REQUEST',
      'GET_INPUT_ALL',
      'GET_URL_PRD',
    ]),
    ...mapMutations([
      'UPDATE_OVERLAY',
    ]),

    show_sessions(){
      this.sessionsDialog = true
    },

    load_proposals(){
      if(this.activeTab == 0)
        var view_type = 'list'
      else if(this.activeTab == 1)
        var view_type = 'list_archive'
      else
        var view_type = 'list_deleted'

      this.list_loading = true
      this.LOAD_LIST_MY_PROPOSALS({view_type: view_type})
      .then((res) => {
        if(this.activeTab == 0)
          this.listProposals = res
        else if(this.activeTab == 1)
          this.listArchiveProposals = res
        else
          this.listDeletedProposals = res
        this.list_loading = false
      })
    },

    update_from_proposal(){
      this.proposalDialogCard = false
      this.load_proposals()
    },

    openPdf(id) {
      this.UPDATE_OVERLAY(true)
      this.GET_URL_PRD(id)
      .then(() => this.UPDATE_OVERLAY(false))
      .catch(() => this.UPDATE_OVERLAY(false))
    },

    async openDetailInfo(item) {
      this.UPDATE_OVERLAY(true)
        this.GET_INPUT_ALL(item.id)
        .then(() => {
          this.UPDATE_OVERLAY(false)
          this.proposalDialogCard = true
        })
    },

    goToEditProposal(item) {
      window.location.href = `/new-proposal/${item.id}`
      // this.$router.push(`/new-proposal/${item.id}`);
    },

    openModal(item) {
      this.proposalName = item.name ? item.name : this.$t('untitled');
      this.deleteId = item.id;
      this.deleteDialog = true;
    },

    async deleteItem() {
      try {
        this.DELETE_REQUEST({
          id: this.GETTERS_LOGIN,
          deleteId: this.deleteId
        })
        .then(() => this.succesAndLoadProposals(this.deleteId))
      } catch (e) {
        console.log('e ---> ', e);
        this.disabledDelete = false
        this.$messageHelper(`${this.$t('error_occurred')}: ${e}`, 'error', 3000)
      }
    },

    succesAndLoadProposals(id) {
      this.$messageHelper(`${this.$t('applications')} № ${this.deleteId} ${this.$t('cancel')}`, 'success', 3000)
      this.deleteDialog = false;
      this.proposalName = '';
      this.deleteId = null;
      this.disabledDelete = false

      this.load_proposals()
    },

  },

  computed: {
    ...mapGetters([
      'GETTERS_LOGIN'
    ]),
  },

  watch: {
    activeTab(val) {
      this.headers = (val == 1 ? this.headers_archive : this.headers_base)
      this.load_proposals()
    },
  },
};

</script>
<style scoped>
  .headline{
    font-size: 12px;
  }
.v-card{
  margin-bottom: 30px;
  -webkit-box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
  box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
  border-width: 0;
  -webkit-transition: all .2s;
  transition: all .2s;
  background-color: #fff;
  border-radius: 13px!important;
}
.sessions-btn-25{
  background-color: rgba(168, 121, 4, 0.2);
  border-radius: 0px 8px 8px 0px;
  margin-left: -10px !important;
  margin-bottom: 0px !important;
  margin-top: 0px !important;

}
.sessions-btn-25:hover{
  -webkit-transform: translateY(-2px);
  transform: translateY(-2px);
}
.new-proposal{
  background-color: rgba(22, 51, 110,0.2);
  border-radius: 0px 8px 8px 0px;
  margin-left: 0px !important;
  margin-bottom: 0px !important;
  margin-top: 14px !important;

}
.new-proposal:hover{
  -webkit-transform: translateY(-2px);
  transform: translateY(-2px);
}
.theme--light.v-application {
    background: rgb(248, 248, 248) !important;
    color: rgba(0, 0, 0, 0.87);
}
</style>
